import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Button } from "react-aria-components";
import { XClose } from "../icons/line.js";
import { badge, badgeText, closeButton, dotIcon, icon } from "./Badge.css.js";
import { Tooltip, TooltipIcon } from "./Tooltip.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BadgeSizeToTooltipSizeMap = {
  s: "xs",
  m: "s",
  l: "m"
};
const BaseBadge = (props, ref) => {
  const $ = _c(33);
  const {
    size: t0,
    color: t1,
    outline: t2,
    children
  } = props;
  const size = t0 === undefined ? "m" : t0;
  const color = t1 === undefined ? "primary" : t1;
  const outline = t2 === undefined ? false : t2;
  const {
    variant: t3
  } = props;
  const variant = t3 === undefined ? "default" : t3;
  const t4 = variant === "iconOnly";
  let t5;
  if ($[0] !== color || $[1] !== outline || $[2] !== size || $[3] !== t4) {
    t5 = badge({
      size,
      color,
      outline,
      iconOnly: t4
    });
    $[0] = color;
    $[1] = outline;
    $[2] = size;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const wrapperClassName = t5;
  if (props.variant === "iconOnly") {
    const {
      leadingIcon: Icon
    } = props;
    let t6;
    if ($[5] !== Icon) {
      t6 = /*#__PURE__*/_jsx(Icon, {
        className: icon
      });
      $[5] = Icon;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] !== ref || $[8] !== t6 || $[9] !== wrapperClassName) {
      t7 = /*#__PURE__*/_jsx("span", {
        ref: ref,
        role: "presentation",
        className: wrapperClassName,
        children: t6
      });
      $[7] = ref;
      $[8] = t6;
      $[9] = wrapperClassName;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    return t7;
  }
  let t6;
  if ($[11] !== props) {
    t6 = iconsForVariant(props);
    $[11] = props;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const {
    leadingIcon: LeadingIcon,
    trailingIcon: TrailingIcon
  } = t6;
  let t7;
  if ($[13] !== size) {
    t7 = badgeText({
      size
    });
    $[13] = size;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== children || $[16] !== t7) {
    t8 = /*#__PURE__*/_jsx("span", {
      className: t7,
      children: children
    });
    $[15] = children;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== props.onClose || $[19] !== variant) {
    t9 = variant === "close" && /*#__PURE__*/_jsx(Button, {
      className: closeButton,
      onPress: props.onClose,
      children: /*#__PURE__*/_jsx(XClose, {
        className: icon
      })
    });
    $[18] = props.onClose;
    $[19] = variant;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== color || $[22] !== props.tooltipText || $[23] !== size) {
    t10 = props.tooltipText != null && /*#__PURE__*/_jsx(Tooltip, {
      text: props.tooltipText,
      theme: "dark",
      children: /*#__PURE__*/_jsx(TooltipIcon, {
        color: color === "white" ? "gray" : color,
        size: BadgeSizeToTooltipSizeMap[size]
      })
    });
    $[21] = color;
    $[22] = props.tooltipText;
    $[23] = size;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== LeadingIcon || $[26] !== TrailingIcon || $[27] !== ref || $[28] !== t10 || $[29] !== t8 || $[30] !== t9 || $[31] !== wrapperClassName) {
    t11 = /*#__PURE__*/_jsxs("span", {
      ref: ref,
      role: "presentation",
      className: wrapperClassName,
      children: [LeadingIcon, t8, TrailingIcon, t9, t10]
    });
    $[25] = LeadingIcon;
    $[26] = TrailingIcon;
    $[27] = ref;
    $[28] = t10;
    $[29] = t8;
    $[30] = t9;
    $[31] = wrapperClassName;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};
const colorToDotColorMap = {
  white: "lightGray",
  gray: "gray",
  primary: "primary",
  error: "red",
  warning: "yellow",
  success: "green",
  blue: "blue"
};
function iconsForVariant(props) {
  const {
    leadingIcon: LeadingIcon,
    trailingIcon: TrailingIcon
  } = props;
  switch (props.variant) {
    case "iconOnly":
      {
        return {
          leadingIcon: LeadingIcon ? /*#__PURE__*/_jsx(LeadingIcon, {
            className: icon
          }) : undefined
        };
      }
    case "dot":
      {
        return {
          leadingIcon: /*#__PURE__*/_jsx(DotComponent, {
            dotColor: props.dotColor ?? colorToDotColorMap[props.color ?? "primary"],
            dotSize: props.dotSize ?? props.size
          })
        };
      }
    case "close":
      {
        return {};
      }
    default:
      {
        return {
          leadingIcon: LeadingIcon ? /*#__PURE__*/_jsx(LeadingIcon, {
            className: icon
          }) : undefined,
          trailingIcon: TrailingIcon ? /*#__PURE__*/_jsx(TrailingIcon, {
            className: icon
          }) : undefined
        };
      }
  }
}
const DotComponent = t0 => {
  const $ = _c(6);
  const {
    dotColor: t1,
    dotSize: t2
  } = t0;
  const dotColor = t1 === undefined ? "gray" : t1;
  const dotSize = t2 === undefined ? "m" : t2;
  let t3;
  if ($[0] !== dotColor || $[1] !== dotSize) {
    t3 = dotIcon({
      color: dotColor,
      size: dotSize
    });
    $[0] = dotColor;
    $[1] = dotSize;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /*#__PURE__*/_jsx("circle", {
      cx: "4",
      cy: "4",
      r: "3",
      fill: "currentColor"
    });
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = /*#__PURE__*/_jsx("svg", {
      className: t3,
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "8",
      viewBox: "0 0 8 8",
      fill: "none",
      children: t4
    });
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export const Badge = /*#__PURE__*/React.forwardRef(BaseBadge);
//# sourceMappingURL=Badge.js.map